import React, { useState, useEffect } from "react";
import Form from "react-bootstrap/Form";
import * as Yup from 'yup';
import { Formik } from 'formik';
import Button from "react-bootstrap/Button";
import UserService from "../services/user.service";
import { useLocation } from "react-router-dom";
import { useSearchParams } from "react-router-dom";


const BACKEND_URL = process.env.REACT_APP_LOCALHOST_URL;

const required = (value) => {
  if (!value) {
    return (
      <div className="alert alert-danger" role="alert">
        This field is required!
      </div>
    );
  }
};



const ResetPassword = (props) => {
  const [message, setMessage] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  let [searchParams, setSearchParams] = useSearchParams();
  const location = useLocation();

  useEffect(() => {
    console.log(searchParams.get("id"));
    //dispatch(getRegistration(searchParams.get("id")));
  }, [location.key]);

  const loginValidationSchema = Yup.object().shape({
    emailaddress: Yup.string()
      .required("Email Address is required"),
    password: Yup.string()
      .required('No password provided.') 
      .matches(
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/,
        "Must Contain 8 Characters, One Uppercase, One Lowercase, One Number and One Special Case Character"),
    passwordConfirmation: Yup.string()
     .oneOf([Yup.ref('password'), null], 'Passwords must match')
  });

  
  const handleResetPassword = async (values, actions) => {
    console.log("VALUES", values.email, values.password);
    setIsSubmitting(true);
    console.log("IN HANDLE LOGIN");
    var status = await UserService.resetPassword(values.emailaddress, values.password, values.passwordConfirmation, searchParams.get("id"));
    console.log("STATUS", status);
    if(status.status === "success") {
        setShowSuccess(true);
        setMessage(null);
    } else {
        setMessage(status.message);
    }
  }

  return (
    <div>
      <div className="row">
      <div className="col-sm">
      </div>
      <div className="col-sm">
        <div className="card card-container">
        Reset your password below.
        <br/>
        <br/>
        <Formik 
        initialValues={{ emailaddress: "" }}
        validationSchema={loginValidationSchema}
        onSubmit={handleResetPassword}
        >
        {/* Callback function containing Formik state and helpers that handle common form actions */}
          {( {values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
          isSubmitting }) => (
            <Form onSubmit={handleSubmit} >
              <Form.Group className="mb-3" controlId="emailaddress">
                <Form.Label>Email Address</Form.Label>
                <Form.Control 
                  name="emailaddress"
                  type="text"
                  placeholder="Email Address"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.emailaddress}
                  className={touched.emailaddress && errors.emailaddress ? "error" : null}
                />
                {touched.emailaddress && errors.emailaddress ? (
                  <div className="error-message">{errors.emailaddress}</div>
                ): null}
              </Form.Group>
              <Form.Group className="mb-3" controlId="password">
                <Form.Label>Password</Form.Label>
                <Form.Control 
                  name="password"
                  type="password"
                  placeholder="Enter Password"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.password}
                  className={touched.password && errors.password ? "error" : null}
                />
                {touched.password && errors.password ? (
                  <div className="error-message">{errors.password}</div>
                ): null}
              </Form.Group>
              <Form.Group className="mb-3" controlId="passwordConfirmation">
                <Form.Label>Password Confirmation</Form.Label>
                <Form.Control 
                  name="passwordConfirmation"
                  type="password"
                  placeholder="Password Confirmation"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.passwordConfirmation}
                  className={touched.passwordConfirmation && errors.passwordConfirmation ? "error" : null}
                />
                {touched.passwordConfirmation && errors.passwordConfirmation ? (
                  <div className="error-message">{errors.passwordConfirmation}</div>
                ): null}
              </Form.Group>
              <Button variant="primary" onClick={handleSubmit} type="submit" disabled={isSubmitting}>
                  Reset Password
                </Button>
              {message && (
              <div className="form-group">
                <div className="alert alert-danger" role="alert">
                  {message}
                </div>
              </div>
             )}
                           {showSuccess && (
                <div className="form-group">
                    <div className="alert alert-success" role="alert">
                    Password reset successful.  <a href="/login">Click here to login.</a>
                    </div>
                </div>
              )}     

     
            </Form>  
      )}
    </Formik>






     
        </div>
      </div>
      </div>
    </div>
  );
};
export default ResetPassword;